// Códigos de motivo retornados pela API (devem casar com erpAPINode/constants/motivos.js).
export const MOTIVOS = {
  MOVIMENTACOES_EXISTENTES: "movimentacoes_existentes",
  NADA_ENCONTRADO: "nada_encontrado",
};
